import { render } from "./PartTable.vue?vue&type=template&id=d346eb8a&ts=true"
import script from "./PartTable.vue?vue&type=script&lang=ts"
export * from "./PartTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__